module.exports = __webpack_public_path__ + "static/media/18.9376c16a.png";